import { useState, useEffect } from 'react';

/**
 * Hook to manage voice mode state and toggle functionality
 * Listens for global voice mode toggle events
 */
export function useVoiceMode() {
  const [voiceModeActive, setVoiceModeActive] = useState(false);

  useEffect(() => {
    const handler = () => setVoiceModeActive(v => !v);
    window.addEventListener('toggle-voice-mode', handler);
    return () => window.removeEventListener('toggle-voice-mode', handler);
  }, []);

  const toggleVoiceMode = () => {
    setVoiceModeActive(prev => !prev);
  };

  const enableVoiceMode = () => {
    setVoiceModeActive(true);
  };

  const disableVoiceMode = () => {
    setVoiceModeActive(false);
  };

  return {
    voiceModeActive,
    setVoiceModeActive,
    toggleVoiceMode,
    enableVoiceMode,
    disableVoiceMode,
  };
}
